import React from "react";
import DistributionPlot from "./DistributionPlot";
import {DistributionSummary} from "./Distribution";
import {DistributionTimeDependence} from "../../../../../mxGraph/HCLTreeNode/HCLTreeVertexValue/ProxyTypes";
import {Tab, Tabs, Typography} from "@material-ui/core";

interface Props {
  distributionSummaries: DistributionSummary[];
  timeDependence?: DistributionTimeDependence;
}

interface State {
  tabIndex: number;
  checked: boolean;
}

interface AggregateDistributionSummary {
  xs:  [number[]] | [];
  pdfs: [number[]] | [];
  cdfs: [number[]] | [];
}

class DistributionSummaryPlot extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      tabIndex: 0,
      checked: false
    }
  }

  private handleTabChange = (e: React.ChangeEvent<{}>, value: any) => {
    this.setState({ tabIndex: value });
  };

  private handleTabIndexChange = (value: any) => {
    this.setState({ tabIndex: value });
  };

  private toggleChecked = (e: React.ChangeEvent<HTMLElement>) => {
    this.setState(prevState => ({ checked: !prevState.checked }))
  };

  private static transformDistSummaries = (summaries: DistributionSummary[]): AggregateDistributionSummary => {
    const output: AggregateDistributionSummary = {
      xs: [],
      pdfs: [],
      cdfs: [],
    };
    summaries.forEach(summary => {
      if (summary != null) {
        //@ts-ignore
        output.xs.push(summary.x);
        //@ts-ignore
        output.pdfs.push(summary.pdf);
        //@ts-ignore
        output.cdfs.push(summary.cdf);
      }
    });
    return output;
  };

  render() {

    const { distributionSummaries, timeDependence } = this.props;
    const { tabIndex, checked } = this.state;
    const summaries = DistributionSummaryPlot.transformDistSummaries(distributionSummaries);
    return (
        <div style={{ width: "100%" }}>
          {/*<FormControlLabel*/}
          {/*  control={*/}
          {/*    <Switch*/}
          {/*      checked={checked}*/}
          {/*      onChange={this.toggleChecked}*/}
          {/*    />*/}
          {/*  }*/}
          {/*  label="logspace"*/}
          {/*/>*/}
          <Tabs
            value={tabIndex}
            variant="fullWidth"
            onChange={this.handleTabChange}
          >
            <Tab label={<Typography color="textPrimary">PDF</Typography>} />
            <Tab label={<Typography color="textPrimary">CDF</Typography>} />
          </Tabs>
          {
            tabIndex === 0 ?
              <DistributionPlot
                xs={summaries.xs}
                ys={summaries.pdfs}
                xLabel={!timeDependence ? undefined : timeDependence === DistributionTimeDependence.TIME_INDEPENDENT ? "probability of occurrence" : "time"}
                xAxisType={checked ? "log" : "linear"}
              />
              :
              <div />
          }
          {
            tabIndex === 1 ?
              <DistributionPlot
                xs={summaries.xs}
                ys={summaries.cdfs}
                xLabel={!timeDependence ? undefined : timeDependence === DistributionTimeDependence.TIME_INDEPENDENT ? "probability of occurrence" : "time"}
                xAxisType={checked ? "log" : "linear"}
              />
              :
              <div />
          }
        </div>
    );
  }
}

export default DistributionSummaryPlot;
